/*
 Provides Props:
 ------------------------------------
 state.timeNow  // unix timestamp UTC
 state.localTimeNow // unix timestamp offset by state.tzOffset

 Responds to:
 --------
 * 'timezone' - by updating state.localTimeNow
 * 'init' - by starting the clock ticker
 * 'clear' - by stopping the ticker
 */

import {roundN} from "../utils";
const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;

export default function (state, widget) {
    const m = widget.m;

    const tickInterval = 5 * MINUTE_MS;

    function _checkTimeNow() {
        state.timeNow = roundN(Date.now(), 1000);
        state.localTimeNow = state.timeNow + (state.tzOffset || 0) * HOUR_MS;
        //console.log('time now:', new Date(state.timeNow));
    }

    // Tell the caller that we should run again at the next whole tickInterval
    function _timeToNextCheck() {
        // milliseconds until the next tick boundary
        let ms = Math.ceil(state.timeNow / tickInterval) * tickInterval - Date.now();
        while (ms <= 0) ms += tickInterval;  // We want a positive wait time
        return ms;
    }

    let ticker;

    function _tick() {
        _checkTimeNow();
        m.redraw();
        // Use repeating timeout rather than interval to avoid clock skew accumulating
        ticker = setTimeout(_tick, _timeToNextCheck());
    }

    // ------------------------------------------------

    state.timeNow = undefined;
    state.localTimeNow = undefined;

    // ------------------------------------------------

    state.on('timezone', _checkTimeNow);

    state.on('init', function () {
        _checkTimeNow(true);
        setTimeout(_tick, _timeToNextCheck());
    });

    state.on('clear', function () {
        clearTimeout(ticker);
    });

}
